import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';
import * as Constants from 'src/constants';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage
        author='OneShop Team'
        dateTime='2022-06-23'
        tag='Depop'
        title='Depop Account Suspended: Everything You Should Know to Avoid This'
      >
        <p>
          Reselling on different marketplaces like Depop is a fruitful venture. With the perfect combination of selling
          strategies and compliance with the platforms' rules, you should be able to generate conversions, earn profits,
          and can eventually get loyal customers.{' '}
        </p>
        <p>
          Unfortunately, some sellers infringe on the platform's terms and conditions, resulting in temporary or
          permanent account suspension. When this happens, an email from Depop is sent to the seller informing them
          about the suspension. But how can you be sure that this won't happen to your Depop account, too?{' '}
        </p>
        <p>
          This article will share how you can steer clear of the violations that can get your Depop account suspended.
          Read on to find out what you should and should not do to keep your reselling business safe.
        </p>

        <h3>Community Guidelines that You Must Follow</h3>
        <p>
          Depop's community guidelines are straightforward. To maintain a healthy and positive experience for all users
          on the platform, all Depop wants is to have all members of its community avoid negativity, respect everyone,
          and, most importantly, maintain all transactions in-app. Anyone proven to go against these policies is at risk
          of getting their account suspended, or worse, banned.{' '}
        </p>
        <p>Here are some rules that you should follow:</p>
        <ul>
          <li>
            <strong>Avoid bullying and harassment.</strong> Being respectful is one of the most important traits of a
            seller. Depop's commitment to equality advocates a non-discriminating environment for all users. Any display
            of misbehavior ( derogatory remarks, bullying, etc) regarding someone’s gender, ethnicity, race, religion,
            sexual orientation, or disability is not tolerated on the platform.{' '}
          </li>
          <li>
            <strong>Don't engage in any display of violence.</strong> An act of violence can come in many forms, and
            Depop is promoting a zero-tolerance policy for such gestures. This may include threats, hate speech, or even
            display or support for violence or harm. This clause also includes the encouragement of inflicting self-harm
            or injury, and any of these are strictly prohibited.
          </li>
          <li>
            <strong>Do not list any illegal items.</strong> Selling illegal items and other items included in{' '}
            <a href='https://depophelp.zendesk.com/hc/en-gb/articles/360001792167-What-are-Depop-s-prohibited-items-'>
              Depop's prohibited items
            </a>{' '}
            list is not allowed on the platform and will be removed. Any sellers proven to be associated with such
            activities may face suspension or account or, if committed repeatedly, will be banned from selling on Depop.
          </li>
          <li>
            <strong>Steer clear from listing or communicating with explicit content.</strong> Depop does not condone any
            form of sexually explicit behavior. This isn't only limited to offering sexual services but also extends to
            communicating with any user committing sexual misconduct. In addition, Depop will ban any users proven to
            promote or distribute sexually explicit or pornographic content.
          </li>
          <li>
            <strong>Do not transact outside Depop.</strong> Depop encourages all users to transact within the app to
            protect their transactions. Always ensure that you or your buyer use the in-app Buy button to have a 100%
            secured transaction on PayPal. Furthermore, asking, making, or accepting payment other than in the app is
            considered a violation of the Terms of Service; hence can also result in account suspension.
          </li>
          <li>
            <strong>Avoid deceiving buyers with fraudulent listings.</strong> Selling of counterfeits and listing items
            to appear authentic is not tolerated on Depop. Also, using stock photos that are not yours, including
            irrelevant tags and keywords, impersonating, and stealing other sellers' listings are a violation of the
            platform's guidelines which can get your account in trouble.
          </li>
          <li>
            <strong>Avoid spamming.</strong> Repeatedly leaving multiple comments on other users' listings or sending a
            bunch of messages to users to ask them to buy your items can get your account suspended. Remember, it is not
            wrong to want more sales but being persistent is different from being pushy.{' '}
          </li>
        </ul>

        <p>Other reasons that may result in account suspension are as follows: </p>
        <ul>
          <li>
            <strong>Payments:</strong> If there is a failed transaction and you need to reimburse a buyer using your
            Depop Payments account, but it has a negative balance, Depop will cover the payment first on your behalf.
            But, note that you must repay the platform with the correct amount. If your debt is not settled when Depop
            collects it from your linked bank account under the Direct Debit mandate, Depop can suspend or terminate
            your access to the Service until your debt is settled.
          </li>
          <li>
            <strong>Chargebacks:</strong> While there are some unavoidable circumstances where chargebacks happen,
            getting regular chargebacks from you as a Seller may lead to an account investigation which may result in
            suspension.
          </li>
          <li>
            <strong>Pending Disputes:</strong> If there are pending disputes that need your response, Depop can suspend
            your account temporarily. To avoid this situation, ensure that you answer any questions from Depop and
            provide them with sufficient evidence to prove your integrity.
          </li>
        </ul>

        <p>
          <strong>Note:</strong> If you think that your account suspension lacks basis or is a mistake, you can always
          appeal Depop's decision and contact them{' '}
          <a href='https://depophelp.zendesk.com/hc/en-gb/requests/new?ticket_form_id=360002023934.'>here</a>. Note that
          when you do this, you must be ready to provide any evidence that the platform may ask you to support your
          case.
        </p>

        <h3>Do more with OneShop</h3>
        <p>
          Getting your Depop account suspended is bad for business. Not only does it affect your integrity as a seller,
          but it can also mean a loss of profits. That is why keeping your account safe and away from getting in trouble
          should always be your top priority. Remember, having a good track record as a seller in the marketplace of
          your choice is essential. And so, with enough knowledge that will keep your account from getting suspended,
          you can focus on doing other things that will help grow your business.
        </p>
        <p>
          Many online sellers have long struggled as this requires a lot of time and effort, and it can be challenging
          to manage all things simultaneously. Good thing that there is a reliable automation service like OneShop that
          you can count on to help you save time and effort with its helpful features.
        </p>
        <p>
          OneShop is an all-in-one automation app trusted by thousands of resellers like you. It offers the easiest way
          to reach more buyers in just a few clicks by crosslisting across marketplaces like Poshmark, Mercari, Tradesy,
          and eBay. It also automatically delists items across platforms once they get sold on another, so you can avoid
          selling a single item at once on multiple marketplaces.{' '}
        </p>
        <p>
          In addition, you can now ensure that your Depop listings are visible to more potential buyers with the app's
          new auto-refreshing feature. This can help your Depop listing placement rank higher in Depop search, which can
          help put your items in front of more potential buyers and increase your sales.{' '}
        </p>
        <p>
          Furthermore, with this app, you can see your performance. You can track sales, set goals, and do things
          effortlessly in-app like order shipping supplies, print shipping labels, schedule package pickups, look up an
          item's registered ID to see what brand the item is, and more.
        </p>
        <p>
          So if you're looking for the perfect automation system to help you succeed in online reselling, OneShop is
          here. Visit <a href='https://tools.oneshop.com/'>OneShop</a> to learn more, or directly{' '}
          <a href='https://tools.oneshop.com/signup'>sign-up here</a> to start your 7-day free trial.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
